


























































helpers = require('../../helpers.coffee')

view_model =
  components:
    contactGroupsList: require('../contact_groups/list')
    newGroupModal: require('../contact_groups/new')

  data: ->
    group_destroy_contacts: false
    selected_group: {}
    current_user: Session.current_user
    filters: {}
    fetching: false
    next_page: true
    total_count: 0
    contact_groups: []

  methods:
    # Routing
    leadsRedirect: ->
      @$router.push '/contatos/leads'

    businessRedirect: ->
      @$router.push '/contatos/empresas'

    groupsRedirect: ->
      @$router.push '/contatos/grupos'

    openNewGroupModal: ->
      EventsBus.$emit 'new-group-modal-show'

    updateContactGroupList: (data) ->
      @contact_groups.push data.contact_group

    openDestroyGroupConfirmationModal: (data) ->
      @selected_group = data.contact_group
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-remove-group'

    destroyGroup: ->
      Loader.on()
      params = { id: @selected_group.id, params: { destroy_contacts: @group_destroy_contacts } }
      @contact_group_resource.destroy @destroyGroupSuccess, @unknownError, params

    destroyGroupSuccess: ->
      Loader.off()
      @excludeGroupFromList @selected_group
      @selected_group = {}
      alertify.success this.$t('groups.actions.delete.success')

    excludeGroupFromList: (contact_group) ->
      index = @contact_groups.findIndex contact_group
      @contact_groups.splice index, 1 if index > -1
      @excludeGroupContactsFromList @selected_group if @group_destroy_contacts

    excludeGroupContactsFromList: (contact_group) ->
      contact_ids = contact_group.contacts.map (contact) -> contact.id
      index = @contacts.length - 1
      while index >= 0
        contact = @contacts[index]
        @contacts.splice index, 1 if contact_ids.indexOf(contact.id) > -1
        index -= 1

    filter: (filters) ->
      @filters = filters
      @contact_groups = []
      @next_page = 1
      @loadData()

    loadData: ->
      return if @fetching || !@next_page
      @fetching = true
      @contact_group_resource.index @loadSuccess, @unknownError,params: {q: @filters, page: @next_page}

    loadSuccess: (resources) ->
      @fetching = false
      @next_page = resources.meta.next_page
      @total_count = resources.meta.total_count
      @contact_groups = @contact_groups.concat(resources.contact_groups)
      Loader.off()

    refreshList: (data, self) ->
      index = -1
      for contact_group, idx in self.contact_groups
        if contact_group.id == data.id
          index = idx
          contact_group = new ContactGroup(data)
      return setTimeout(self.refreshList(data, sefl), 1000) unless index >= 0
      self.contact_groups[index] = new ContactGroup(data)
      Vue.set(self.contact_groups, index, new ContactGroup(data))
      self.$forceUpdate()

    subscribeToContactGroupUpdateChannel: ->
      self = @
      @removeSubscription()
      @subscription = ActionCable.cable.subscriptions.create { channel: 'ContactGroupUpdateChannel', user_id: @user_id },
        received: (data) =>
          @refreshList(data, self)

    removeSubscription: ->
      ActionCable.cable.subscriptions.remove(@subscription) if @subscription

    showNabBars: ->
      !Session.current_user.new_ui

  created: ->
    @contact_group_resource = new ContactGroupsResource Session.current_company.id
    @subscribeToContactGroupUpdateChannel()
    @loadData()

  beforeDestroy: ->
    @removeSubscription()

exports.default = helpers.vue_include(view_model, helpers.form,
                                                  helpers.contacts.list_view_modes, helpers.contacts.list_wrapper,
                                                  helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/groups.vue